import { useCallback } from "react";

import { useResultHandler } from "../../../hooks/useResultHandler";
import { toUpdateSurveyRequest } from "../utils/surveyRequestMapper";
import { useUpdateSurvey } from "./useUpdateSurvey";
import type { SurveyFormValues } from "../types/survey.types";

export const useUpdateSurveySubmission = () => {
  const { updateSurvey, loading } = useUpdateSurvey();
  const { handleResult, handleError } = useResultHandler();

  const submitUpdate = useCallback(
    async (id: string, formValues: SurveyFormValues, originalEndTime?: string) => {
      try {
        const response = await updateSurvey(
          id,
          toUpdateSurveyRequest(formValues, originalEndTime),
        );
        const success = handleResult(response, { showSuccessToast: false });
        return { success, response };
      } catch (error: unknown) {
        handleError(error, "An error occurred while updating the survey");
        return { success: false, response: undefined };
      }
    },
    [handleError, handleResult, updateSurvey],
  );

  return { submitUpdate, loading };
};
